import { render, staticRenderFns } from "./LRightContact.vue?vue&type=template&id=a483263e&scoped=true&"
import script from "./LRightContact.vue?vue&type=script&lang=js&"
export * from "./LRightContact.vue?vue&type=script&lang=js&"
import style0 from "./LRightContact.vue?vue&type=style&index=0&id=a483263e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a483263e",
  null
  
)

export default component.exports